import React, {
    useContext, useState, useMemo, useCallback
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { useAuthentication } from 'gw-digital-auth-react';
import { TranslatorContext } from '@jutro/locale';
import { Link } from 'gw-components-platform-react';
import metadata from './VerifyPasswordComponent.metadata.json5';
import messages from './ChangePasswordComponent.messages';
import styles from './ChangePasswordComponent.modules.scss';

function VerifyPasswordComponent(props) {
    const { setPasswordresetcode } = props;
    const auth = useAuthentication();
    const translator = useContext(TranslatorContext);
    const [passwordError, updatePasswordError] = useState('');
    const { verifyPassword } = useAuthentication();
    const [formData, updateFormData] = useState({});

    const readValue = useCallback(
        (id, path) => {
            return _.get(formData, path);
        },
        [formData]
    );

    const writeValue = useCallback(
        (value, path) => {
            const nextFormData = _.cloneDeep(formData);
            _.set(nextFormData, path, value);
            updateFormData(nextFormData);
        },
        [formData]
    );

    const verifyUserPassword = useCallback(() => {
        const username = auth.user_name;
        const password = _.get(formData, 'password');

        return verifyPassword({
            username: username,
            password: password
        }).then((res) => {
            if (res.status === 401) {
                updatePasswordError('passwordError');
            } else {
                updatePasswordError('');
                const resetCodeValue = res.headers.get('passwordResetCode');
                setPasswordresetcode(resetCodeValue);
            }
        })
            .catch(_.noop());
    }, [auth.user_name, formData, setPasswordresetcode, verifyPassword]);


    const phoneToTrigger = (event, agentPhone) => {
        event.preventDefault();
        window.location = `tel:${agentPhone}`;
    };

    const mailToTrigger = useCallback((event, email) => {
        event.preventDefault();
        window.location = `mailto:${email}`;
    }, []);

    const getNeedHelpLink = useMemo(() => {
        return (
            <span className={'hyperlink'}>
                {translator(messages.needHelpText)}
                {' '}
                <Link onClick={(e) => phoneToTrigger(e, '833-481-5976')} href="/">
                    833-481-5976
                </Link>
				&nbsp; Ext. 9020
                &nbsp; or email at&nbsp;
                <Link onClick={(e) => mailToTrigger(e, 'optimsupport@heartlandfarmmutual.com')} href="/">
                    optimsupport@hfmi.ca
                </Link>
            </span>

        );
    }, [mailToTrigger, translator]);


    const overrideProps = {
        '@field': {
            onValueChange: writeValue
        },
        errorMsg: {
            message: translator(messages[passwordError]),
            visible: !!passwordError
        },
        verifyPasswordButton: {
            onClick: verifyUserPassword,
            disabled: _.isUndefined(formData.password) || _.isEmpty(formData.password)
        },
        needHelpSection: {
            content: getNeedHelpLink,
        }

    };

    const resolvers = {
        resolveValue: readValue,
        resolveCallBack: {
            verifyUserPassword: verifyUserPassword
        },
        resolveClassNameMap: styles,
    };


    return renderContentFromMetadata(
        metadata.pageContent,
        overrideProps,
        resolvers
    );
}

VerifyPasswordComponent.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({})
    })
};

VerifyPasswordComponent.defaultProps = {
    location: {}
};

export default VerifyPasswordComponent;
